var render, staticRenderFns
import script from "./notfound.vue?vue&type=script&lang=js&"
export * from "./notfound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcd14a90')) {
      api.createRecord('fcd14a90', component.options)
    } else {
      api.reload('fcd14a90', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-2PtMITDlJ8ZSM/JS/comp/notfound.vue"
export default component.exports